// Wrap an opener so the Home module is active first. Journey workspaces only
// render under activeModule === "home", so openers invoked from other tabs
// (Programs menu) must switch there before opening.
export default function withHomeModule(setActiveModule, fn) {
  if (typeof fn !== "function") return undefined;
  return (...args) => {
    setActiveModule("home");
    return fn(...args);
  };
}
